module.exports = __webpack_public_path__ + "static/media/our_services.1676bccb.png";